<template>
    <div class="parent-container">
        <div class="content-container" v-if="showMode==='list'">
            <div class="topic-sign-title">
                <div class="topic-sign-title-l" @click="backRaceManager">
                    <svg t="1766640149434" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13111" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="13112"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#3b62f8" p-id="13113" data-spm-anchor-id="a313x.search_index.0.i15.3a373a81dKtAXk" class="selected"></path></svg>
                </div>
                <div class="topic-sign-title-r">活动管理</div>
            </div>
            <div class="topic-sign-name">（{{info.activityName}}）</div>
            <div class="topic-status-container">
                <div :class="status===1?'status-item-container item-active':'status-item-container'" @click="changeStatus(1)">
                    <div class="status-time-container">
                        <div class="status-time1">报名阶段</div>
                        <div class="status-time2">{{ timestampDate2(info.beginTime)}}&nbsp;-&nbsp;{{ timestampDate2(info.endTime)}}</div>
                    </div>
                    <div :class="status===1?'status-fx-container item-active':'status-fx-container'">
                        ＞
                    </div>
                </div>

                <div v-if="info.checkMode==='2'||info.checkMode==='3'" :class="status===2?'status-item-container item-active':'status-item-container'" @click="changeStatus(2)">
                    <div class="status-time-container">
                        <div class="status-time1">初审阶段</div>
                        <div class="status-time2">{{ timestampDate2(info.csBeginTime)}}&nbsp;-&nbsp;{{ timestampDate2(info.csEndTime)}}</div>
                    </div>
                    <div :class="status===2?'status-fx-container item-active':'status-fx-container'">
                        ＞
                    </div>
                </div>

                <div v-if="info.checkMode==='3'" :class="status===3?'status-item-container item-active':'status-item-container'" @click="changeStatus(3)">
                    <div class="status-time-container">
                        <div class="status-time1">复审阶段</div>
                        <div class="status-time2">{{ timestampDate2(info.fsBeginTime)}}&nbsp;-&nbsp;{{ timestampDate2(info.fsEndTime)}}</div>
                    </div>
                    <div :class="status===3?'status-fx-container item-active':'status-fx-container'">
                        ＞
                    </div>
                </div>

                <div :class="status===4?'status-item-container item-active':'status-item-container'" @click="changeStatus(4)">
                    <div class="status-time-container">
                        <div class="status-time1">终审阶段</div>
                        <div class="status-time2">{{ timestampDate2(info.zsBeginTime)}}&nbsp;-&nbsp;{{ timestampDate2(info.zsEndTime)}}</div>
                    </div>
                    <div class="status-fx-container">
                    </div>
                </div>
            </div>
            <div class="list-title-container">
                <div class="list1" v-if="status===1">报名列表</div>
                <div class="list1" v-if="status===2||status===3||status===4">审核管理</div>
                <div v-if="status===1" class="status-info-bm">报名阶段</div>
                <div v-if="status===2" class="status-info-kt">初审阶段</div>
                <div v-if="status===3" class="status-info-zq">复审阶段</div>
                <div v-if="status===4" class="status-info-jt">终审阶段</div>
            </div>
            <!--报名列表-->
            <div class="bre9e mt5">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          height="calc(100vh - 310px)"
                          :data="dataList"
                          class="custom-table"
                          highlight-current-row>
                    <el-table-column type="index"  fixed="left" align="center" label="序号" width="60" />
                    <el-table-column align="center" label="报名时间" width="130" prop="">
                        <template #default="scope">
                            <div>
                                {{ timestampToTime(scope.row.submitTime) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="教师姓名" width="80" prop="trueName"/>
                    <el-table-column width="95" align="center" label="学段学科">
                        <template #default="scope">
                            <el-text>
                                {{scope.row.periodName?scope.row.periodName:'--'}}•{{scope.row.subjectName?scope.row.subjectName:'--'}}
                            </el-text>
                        </template>
                    </el-table-column>
                    <el-table-column width="200" align="center" label="所属单位" prop="orgName">
                    </el-table-column>
                    <el-table-column width="80" align="center" label="最高学历" prop="qualificationName">
                    </el-table-column>
                    <el-table-column width="100" align="center" label="技术职称" prop="rankLevelName">
                    </el-table-column>
                    <el-table-column width="200" align="center" label="课例名称" prop="lessonName">
                    </el-table-column>
                    <!--初审-->
                    <el-table-column v-if="status===2" width="80" fixed="right" align="center" label="分配状态">
                        <template #default="scope">
                            <div v-if="scope.row.csStatus===1" class="tab-dfp">待分配</div>
                            <div v-if="scope.row.csStatus===2||scope.row.csStatus===3||scope.row.csStatus===4" class="tab-yfp">已分配</div>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="status===2" width="80" fixed="right" align="center" label="分配情况" prop="csCheckUserName">
                    </el-table-column>
                    <el-table-column v-if="status===2" width="90" fixed="right" align="center" label="审核状态">
                        <template #default="scope">
                            <div v-if="scope.row.csStatus===1||scope.row.csStatus===2" class="tab-dfp">未审核</div>
                            <div v-if="scope.row.csStatus===3" class="tab-shtg">已通过</div>
                            <div v-if="scope.row.csStatus===4" class="tab-shjj">已拒绝</div>
                        </template>
                    </el-table-column>
                    <!--复审-->
                    <el-table-column v-if="status===3" width="80" fixed="right" align="center" label="分配状态">
                        <template #default="scope">
                            <div v-if="scope.row.fsStatus===1" class="tab-dfp">待分配</div>
                            <div v-if="scope.row.fsStatus===2||scope.row.fsStatus===3||scope.row.fsStatus===4" class="tab-yfp">已分配</div>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="status===3" width="80" fixed="right" align="center" label="分配情况" prop="fsCheckUsersName">
                    </el-table-column>
                    <el-table-column v-if="status===3" width="100" fixed="right" align="center" label="审核进度">
                        <template #default="scope">
                            <div class="tab-fpsh1">分配{{scope.row.fsDivideCount}},审核{{scope.row.fsCheckCount}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="status===3" width="100" fixed="right" align="center" label="审核结果">
                        <template #default="scope">
                            <div class="tab-dsh" v-if="scope.row.fsStatus!==3">待审核</div>
                            <div v-if="scope.row.fsStatus===3">{{scope.row.fsScore}}</div>
                        </template>
                    </el-table-column>
                    <!--终审-->
                    <el-table-column v-if="status===4" width="80" fixed="right" align="center" label="分配状态">
                        <template #default="scope">
                            <div v-if="scope.row.zsStatus===1" class="tab-dfp">待分配</div>
                            <div v-if="scope.row.zsStatus===2||scope.row.zsStatus===3||scope.row.zsStatus===4" class="tab-yfp">已分配</div>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="status===4" width="80" fixed="right" align="center" label="分配情况" prop="zsCheckUsersName">
                    </el-table-column>
                    <el-table-column v-if="status===4" width="100" fixed="right" align="center" label="审核进度">
                        <template #default="scope">
                            <div class="tab-fpsh1">分配{{scope.row.zsDivideCount}},审核{{scope.row.zsCheckCount}}</div>
                        </template>
                    </el-table-column>
                    <!--终审不现场评比-->
                    <el-table-column v-if="status===4&&info.isEva===0" width="100" fixed="right" align="center" label="综合分">
                        <template #default="scope">
                            <div class="tab-dsh" v-if="scope.row.zsStatus!==3">评审中</div>
                            <div v-if="scope.row.zsStatus===3">{{scope.row.zsScore}}</div>
                        </template>
                    </el-table-column>
                    <!--终审现场评比-->
                    <el-table-column v-if="status===4&&info.isEva===1" width="80" fixed="right" align="center" label="线上分">
                        <template #default="scope">
                            <div class="tab-dsh" v-if="scope.row.zsStatus!==3">评审中</div>
                            <div v-if="scope.row.zsStatus===3">{{scope.row.zsScore}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="status===4&&info.isEva===1" width="80" fixed="right" align="center" :label="'现场分'">
                        <template #default="scope">
                            <div class="tab-dsh" v-if="scope.row.xcStatus===0&&scope.row.zsStatus!==3">评审中</div>
                            <el-button type="primary" size="small" v-if="scope.row.xcStatus===0&&scope.row.zsStatus===3" @click="lrXcScore(scope.row)">录入</el-button>
                            <el-tooltip
                              class="box-item"
                              effect="dark"
                              content="点击修改现场分"
                              placement="bottom">
                                <div v-if="scope.row.xcStatus===1" style="color: #409efe;cursor: pointer;" @click="editXcScore(scope.row)">{{scope.row.xcScore}}</div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="status===4&&info.isEva===1" width="80" fixed="right" align="center" prop="zhScore" :label="'综合分'">
                        <template #default="scope">
                            <div style="color: #409efe;cursor: pointer;" v-if="!scope.row.zhScore">--</div>
                            <div v-if="scope.row.xcStatus===1" style="color: #409efe;cursor: pointer;" >{{scope.row.zhScore}}</div>
                        </template>
                    </el-table-column>
                    <!--奖项评级-->
                    <el-table-column v-if="status===4" width="90" fixed="right" align="center" :label="'定级'">
                        <template #default="scope">
                            <el-button type="primary" size="small" v-if="scope.row.awardStatus===0" @click="awardLevel(scope.row)">定级</el-button>
                            <el-tooltip
                              class="box-item"
                              effect="dark"
                              content="点击查看奖状"
                              placement="bottom">
                                <el-button v-if="scope.row.awardStatus===1" type="primary" size="small" @click="viewAwardLevel(scope.row)">{{scope.row.award.awardName}}</el-button>
                            </el-tooltip>
                        </template>
                    </el-table-column>

                    <el-table-column fixed="right" label="操作" align="center" width="160">
                        <template #default="scope">
                            <el-button v-if="status===1" type="primary" size="small" @click="viewRaceSign(scope.row)">查看</el-button>
                            <!--初审分配-->
                            <el-button v-if="status===2" type="primary" size="small" @click="viewCsRaceSign(scope.row)">查看</el-button>
                            <el-button v-if="status===2" :disabled="scope.row.csStatus===3||scope.row.csStatus===4" type="primary" size="small" @click="csFpRaceSign(scope.row)">分配</el-button>
                            <!--复审分配-->
                            <el-button v-if="status===3" type="primary" size="small" @click="viewFsRaceSign(scope.row)">查看</el-button>
                            <el-button v-if="status===3" :disabled="scope.row.fsStatus===3" type="primary" size="small" @click="fsFpRaceSign(scope.row)">分配</el-button>
                            <!--终审分配-->
                            <el-button v-if="status===4" type="primary" size="small" @click="viewZsRaceSign(scope.row)">查看</el-button>
                            <el-button v-if="status===4" :disabled="scope.row.zsStatus===3" type="primary" size="small" @click="zsFpRaceSign(scope.row)">分配</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="zdyfy">
                <pagination class="zdyfy" :background="false" :pageSizes="[10, 20, 30]" :total="total"
                            :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getPageTopicSign" />
            </div>
        </div>

        <!-- 初审审核分配-->
        <el-dialog  v-model="isCsFpShow" width="640px" :show-close="false">
            <div class="topic-fp-title">初审审核分配</div>
            <el-card class="fp-container" :body-style="{padding: '10px 10px 10px 10px'}">
                <div class="check-top-container">
                    <div class="refresh-container" >
                        <div class="refresh-icon" @click="queryCheckUser">
                            <img class="img-100" src="../../../assets/refresh.png" alt="">
                        </div>
                        <div class="refresh-title" @click="queryCheckUser">刷新列表</div>
                    </div>
                    <div class="search-container">
                        <el-input v-model="checkUserName" class="w-50 m-2"
                                  placeholder="按姓名搜索专家" :prefix-icon="Search"/>
                    </div>
                </div>
                <el-scrollbar class="fp-scrollbar" >
                    <div v-for="item in filterCheckUser" class="check-user-item">
                        <div class="sel-container" @click="selCsCheckUser(item.userId)">
                            <div class="check-icon-container">
                                <img class="img-100" v-if="!this.checkForm.userIds.includes(item.userId)" src="../../../assets/img/uncheck.png" alt="">
                                <img class="img-100" v-if="this.checkForm.userIds.includes(item.userId)" src="../../../assets/img/checked.png" alt="">
                            </div>
                            <div class="check-icon-word">
                                分配
                            </div>
                        </div>
                        <div class="sel-user-container">
                            <div class="user-check-data">
                                <div class="data-user">{{item.trueName}}</div>
                                <div class="data-item">已分配：{{item.fpCount}}</div>
                                <div class="data-item">已评估：{{item.shCount}}</div>
                            </div>
                            <div class="user-check-pro">
                                <el-progress :percentage="item.rateCount" />
                            </div>
                        </div>
                    </div>
                </el-scrollbar>
            </el-card>

            <div class="fp-btn-container">
                <el-button type="primary" style="margin: auto" @click="submitCheckInfo">确认</el-button>
            </div>
        </el-dialog>

        <!-- 复审审核分配-->
        <el-dialog  v-model="isFsFpShow" width="640px" :show-close="false">
            <div class="topic-fp-title">终审审核分配</div>
            <el-card class="fp-container" :body-style="{padding: '10px 10px 10px 10px'}">
                <div class="check-top-container">
                    <div class="refresh-container" >
                        <div class="refresh-icon" @click="queryCheckUser">
                            <img class="img-100" src="../../../assets/refresh.png" alt="">
                        </div>
                        <div class="refresh-title" @click="queryCheckUser">刷新列表</div>
                    </div>
                    <div class="search-container">
                        <el-input v-model="checkUserName" class="w-50 m-2"
                                  placeholder="按姓名搜索专家" :prefix-icon="Search"/>
                    </div>
                </div>
                <el-scrollbar class="fp-scrollbar" >
                    <div v-for="item in filterCheckUser" class="check-user-item">
                        <div class="sel-container" @click="selCheckUser(item.userId)">
                            <div class="check-icon-container">
                                <img class="img-100" v-if="!this.checkForm.userIds.includes(item.userId)" src="../../../assets/img/uncheck.png" alt="">
                                <img class="img-100" v-if="this.checkForm.userIds.includes(item.userId)" src="../../../assets/img/checked.png" alt="">
                            </div>
                            <div class="check-icon-word">
                                分配
                            </div>
                        </div>
                        <div class="sel-user-container">
                            <div class="user-check-data">
                                <div class="data-user">{{item.trueName}}</div>
                                <div class="data-item">已分配：{{item.fpCount}}</div>
                                <div class="data-item">已评估：{{item.shCount}}</div>
                            </div>
                            <div class="user-check-pro">
                                <el-progress :percentage="item.rateCount" />
                            </div>
                        </div>
                    </div>
                </el-scrollbar>
            </el-card>

            <div class="fp-btn-container">
                <el-button type="primary" style="margin: auto" @click="submitCheckInfo">确认</el-button>
            </div>
        </el-dialog>

        <!-- 终审审核分配-->
        <el-dialog  v-model="isZsFpShow" width="640px" :show-close="false">
            <div class="topic-fp-title">终审审核分配</div>
            <el-card class="fp-container" :body-style="{padding: '10px 10px 10px 10px'}">
                <div class="check-top-container">
                    <div class="refresh-container" >
                        <div class="refresh-icon" @click="queryCheckUser">
                            <img class="img-100" src="../../../assets/refresh.png" alt="">
                        </div>
                        <div class="refresh-title" @click="queryCheckUser">刷新列表</div>
                    </div>
                    <div class="search-container">
                        <el-input v-model="checkUserName" class="w-50 m-2"
                                  placeholder="按姓名搜索专家" :prefix-icon="Search"/>
                    </div>
                </div>
                <el-scrollbar class="fp-scrollbar" >
                    <div v-for="item in filterCheckUser" class="check-user-item">
                        <div class="sel-container" @click="selCheckUser(item.userId)">
                            <div class="check-icon-container">
                                <img class="img-100" v-if="!this.checkForm.userIds.includes(item.userId)" src="../../../assets/img/uncheck.png" alt="">
                                <img class="img-100" v-if="this.checkForm.userIds.includes(item.userId)" src="../../../assets/img/checked.png" alt="">
                            </div>
                            <div class="check-icon-word">
                                分配
                            </div>
                        </div>
                        <div class="sel-user-container">
                            <div class="user-check-data">
                                <div class="data-user">{{item.trueName}}</div>
                                <div class="data-item">已分配：{{item.fpCount}}</div>
                                <div class="data-item">已评估：{{item.shCount}}</div>
                            </div>
                            <div class="user-check-pro">
                                <el-progress :percentage="item.rateCount" />
                            </div>
                        </div>
                    </div>
                </el-scrollbar>
            </el-card>

            <div class="fp-btn-container">
                <el-button type="primary" style="margin: auto" @click="submitCheckInfo">确认</el-button>
            </div>
        </el-dialog>

        <!-- 录入现场分-->
        <el-dialog v-model="isXcScoreShow" width="320px" :show-close="false">
            <div class="topic-fp-title" style="margin-bottom: 20px">录入现场分</div>
            <el-form ref="xcScoreForm" :model="xcScoreForm" :rules="xcScoreFormRules">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label-width="80px" label="现场分" prop="score">
                            <el-input-number v-model="xcScoreForm.score" min="1" max="100" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <template #footer>
                <div class="disflex-row-center">
                    <el-button type="primary" @click="submitXcScore">确 定</el-button>
                    <el-button @click="isXcScoreShow = !isXcScoreShow">取 消</el-button>
                </div>
            </template>
        </el-dialog>

        <!--报名资料-->
        <div class="detail-mode" v-if="showMode==='bm'">
            <bm-activity-sign-info :info-id="signId" @change-active-mode="changeActiveModel"/>
        </div>

        <!--初审资料资料-->
        <div class="detail-mode" v-if="showMode==='cs'">
            <cs-activity-sign-info :info-id="signId" @change-active-mode="changeActiveModel"/>
        </div>

        <!--复审资料资料-->
        <div class="detail-mode" v-if="showMode==='fs'">
            <fs-activity-sign-info :info-id="signId" @change-active-mode="changeActiveModel"/>
        </div>

        <!--终审资料资料-->
        <div class="detail-mode" v-if="showMode==='zs'">
            <zs-activity-sign-info :info-id="signId" @change-active-mode="changeActiveModel"/>
        </div>

        <!-- 录入现场分-->
        <el-dialog v-model="isXcScoreShow" width="320px" :show-close="false">
            <div class="topic-fp-title" style="margin-bottom: 20px">录入现场分</div>
            <el-form ref="xcScoreForm" :model="xcScoreForm" :rules="xcScoreFormRules">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label-width="80px" label="现场分" prop="score">
                            <el-input-number v-model="xcScoreForm.score" min="1" max="100" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <div style="color: #a9abad;width:100%;text-align: center;">温馨提示：现场分满分100</div>
            </el-form>
            <template #footer>
                <div class="disflex-row-center">
                    <el-button type="primary" @click="submitXcScore">确 定</el-button>
                    <el-button @click="isXcScoreShow = !isXcScoreShow">取 消</el-button>
                </div>
            </template>
        </el-dialog>

        <!-- 评审奖状定级 -->
        <el-dialog v-model="isAwardLevelShow" width="800px" top="20px" center :show-close="false">
            <div class="award-title" >奖状定级</div>
            <el-form ref="awardForm" :model="awardForm" :rules="awardFormRules">
                <el-row>
                    <el-col :span="5">
                        <el-form-item label-width="80px" label="教师姓名" prop="trueName">
                            <el-input v-model="awardForm.trueName" placeholder="请输入教师姓名"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label-width="80px" label="主办单位" prop="orgName">
                            <el-input v-model="awardForm.orgName" placeholder="请输入主办单位名称"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="9">
                        <el-form-item label-width="80px" label="定级名称" prop="awardName">
                            <el-input v-model="awardForm.awardName" placeholder="请输入定级名称：如一等奖"/>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="award-par-container" ref="awardElement">
                <div class="award-container">
                    <img class="img-100" src="../../../assets/awardImg/award_template.jpg" id="image" alt crossorigin="anonymous" />
                </div>
                <div class="award-info-container" >
                    <div class="award-info-title">荣誉证书</div>
                    <div class="award-info-name">{{awardForm.trueName}}:</div>
                    <div class="award-info-race">
                        您在“{{awardForm.raceName}}”竞赛活动中表现突出，经评审获得
                    </div>
                    <div class="award-info-awardname">{{awardForm.awardName}}</div>
                    <div class="award-info-race">特发此证，以资鼓励！</div>
                    <div class="award-info-org">主办单位：{{awardForm.orgName}}</div>
                    <div class="award-info-time">{{awardForm.timeInfo}}</div>
                </div>
            </div>


            <template #footer>
                <div class="disflex-row-center">
                    <el-button type="primary" @click="generateImage">确 定</el-button>
                    <el-button @click="isAwardLevelShow = !isAwardLevelShow">取 消</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { serviceUrl } from "@/utils/global"
import { activityInfo,checkUserList } from "@/api/admin/activity"
import {pageActivitySign, divideCheckUser, activitySignXcScore, activitySignAwardRate} from "@/api/admin/raceSign"
import {timestampDate2, timestampToTime} from "@/utils/date";
import {Search} from "@element-plus/icons";
import bmActivitySignInfo from "@/components/homeManager/activity/bmActivitySignInfo";
import csActivitySignInfo from "@/components/homeManager/activity/csActivitySignInfo";
import fsActivitySignInfo from "@/components/homeManager/activity/fsActivitySignInfo";
import zsActivitySignInfo from "@/components/homeManager/activity/zsActivitySignInfo";
import html2canvas from "html2canvas";
export default {
    name: "activityDivideManager",
    components: {bmActivitySignInfo,csActivitySignInfo,fsActivitySignInfo,zsActivitySignInfo},
    props:{
        infoId:{
            type: String,
            default:null,
        },
    },
    watch:{
        infoId(newValue,oldValue){
            this.activityId = newValue;
            this.queryCheckUserForm.raceId = newValue
            this.getRaceInfo()
        },
    },
    data() {
        return {
            listMode:'list',
            bmMode:'bm',
            csMode:'cs',
            fsMode:'fs',
            zsMode:'zs',
            showMode:"list",
            role:this.$storage.get("role") ,
            userId:JSON.parse(this.$storage.get("userInfo")).userId,
            serviceUrl,
            timestampToTime,
            timestampDate2,
            activityId:'',
            signId:'',
            info:{},
            status:0,
            total: 0,
            pageCount:0,
            dataList: [],
            activeModel:'1',
            isCsFpShow:false,
            isFsFpShow:false,
            isZsFpShow:false,
            isXcScoreShow:false,
            isAwardLevelShow:false,
            statusList:[
                { name: '初始阶段', value: 0 },
                { name: '报名阶段', value: 1 },
                { name: '中期检查', value: 2 },
                { name: '开题论证', value: 3 },
                { name: '结题验收', value: 4 },
                { name: '课题结束', value: 5 },
            ],
            queryParams: {
                raceId: '',
                status: '',
                signType:2,
                pageNum: 1,
                pageSize: 10,
            },
            queryCheckUserForm:{
                activityId:'',
                status:'',
            },
            checkUserName:'',
            checkUserList:[],
            checkForm:{
                signId:'',
                userIds:'',
                status:'',
            },
            xcScoreForm:{
                signId:'',
                score:'',
            },
            xcScoreFormRules:{
                score: [{ required: true, message: "请输入现场分", trigger: "blur" },],
            },
            awardForm:{
                signId:'',
                trueName:'',
                raceName:'',
                awardName:'',
                orgName:'',
                timeInfo:'',
                imgInfo:'',
            },
            awardFormRules:{
                trueName: [{ required: true, message: "请输入获奖人名称", trigger: "blur" },],
                orgName: [{ required: true, message: "请输入主办单位", trigger: "blur" },],
                awardName: [{ required: true, message: "请输入竞赛评奖定级名称", trigger: "blur" },],
            },
        };
    },
    created() {},
    mounted() {
        this.activityId = this.infoId;
        this.queryCheckUserForm.raceId = this.infoId
        this.getRaceInfo()
    },
    unmounted() {},
    computed: {
        Search() {
            return Search
        },
        filterCheckUser(){
            if (this.checkUserName=== ''){
                return this.checkUserList;
            }
            return this.checkUserList.filter((item)=>{
                return item.trueName.includes(this.checkUserName)
            })
        }
    },
    methods: {
        getRaceInfo() {
            activityInfo({ activityId: this.activityId }).then(res => {
                if (res.data.code === 1) {
                    this.info = res.data.data;
                    this.status = this.info.status;
                    this.queryParams.status = this.info.status;
                    this.queryParams.raceId = this.info.activityId;
                    this.queryCheckUserForm.activityId = this.info.activityId;
                    this.queryCheckUserForm.status = this.info.status;
                    this.getPageRaceSign();
                }else {
                    this.$message.error("请求出错")
                }

            })
        },
        changeStatus(status){
            this.status = status;
            this.queryParams.status = status;
            this.queryCheckUserForm.status = status;
            if (status>this.info.status){
                this.$message.info("暂未进行到该阶段")
                return;
            }
            this.getPageRaceSign();
            this.queryCheckUser();
        },
        getPageRaceSign(e){
            this.dataList = []
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageActivitySign(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.dataList = res.data.data.list;
                    this.total = res.data.data.total;
                    this.pageCount = res.data.data.totalPage;
                }else{
                    this.$message.error("请求出错")
                }
            })
        },
        viewRaceSign(row){
            this.signId = row.signId;
            this.showMode = this.bmMode;
        },
        viewCsRaceSign(row){
            this.signId = row.signId;
            this.showMode = this.csMode
        },
        viewFsRaceSign(row){
            this.signId = row.signId;
            this.showMode = this.fsMode;
        },
        viewZsRaceSign(row){
            this.signId = row.signId;
            this.showMode = this.zsMode;
        },
        zsFpRaceSign(row){
            this.checkForm.signId = row.signId;
            this.isZsFpShow = true;
            this.checkForm.userIds = "";
            if (row.zsCheckUsers){
                this.checkForm.userIds = row.zsCheckUsers;
            }
            this.queryCheckUser()
        },
        fsFpRaceSign(row){
            this.checkForm.signId = row.signId;
            this.isFsFpShow = true;
            this.checkForm.userIds = "";
            if (row.fsCheckUsers){
                this.checkForm.userIds = row.fsCheckUsers;
            }
            this.queryCheckUser()
        },
        csFpRaceSign(row){
            this.checkForm.signId = row.signId;
            this.isCsFpShow = true;
            this.checkForm.userIds = "";
            if (row.csCheckUser){
                this.checkForm.userIds = row.csCheckUser;
            }
            this.queryCheckUser()
        },
        submitCheckInfo(){
            if(this.checkForm.userIds===''||
              this.checkForm.userIds===null
              || this.checkForm.userIds===undefined){
                this.$message.error("请选择审核人")
                return;
            }
            this.checkForm.status = this.status;
            divideCheckUser(this.checkForm).then(res => {
                if (res.data.code === 1) {
                    this.isCsFpShow = false;
                    this.isFsFpShow = false;
                    this.isZsFpShow = false;
                    this.getPageRaceSign()
                }else{
                    this.$message.error("请求出错")
                }
            })
        },
        queryCheckUser(){
            checkUserList(this.queryCheckUserForm).then(res => {
                if (res.data.code === 1) {
                    this.checkUserList = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        selCheckUser(userId){
            if (this.checkForm.userIds&&this.checkForm.userIds.includes(userId)){
                this.checkForm.userIds = this.checkForm.userIds.replace(userId+',',"")
            }else {
                this.checkForm.userIds = this.checkForm.userIds+userId+',';
            }
        },
        selCsCheckUser(userId){
            this.checkForm.userIds =userId;
        },
        backRaceManager(){
            this.$emit('change-active-mode', this.listMode,"1");
        },
        lrXcScore(row){
            this.xcScoreForm.signId = row.signId;
            this.isXcScoreShow = true;
        },
        editXcScore(row){
            this.xcScoreForm.signId = row.signId;
            this.xcScoreForm.score = row.xcScore;
            this.isXcScoreShow = true;
        },
        submitXcScore(){
            this.$refs["xcScoreForm"].validate(valid => {
                if (!valid){
                    return
                }
                activitySignXcScore(this.xcScoreForm).then(res => {
                    if (res.data.code === 1) {
                        this.isXcScoreShow = false;
                        this.getPageRaceSign()
                    }else{
                        this.$message.error("请求出错")
                    }
                })
            })

        },
        changeActiveModel(model,activeItem){
            this.showMode = model;
        },
        awardLevel(row){
            this.isAwardLevelShow = true;
            this.awardForm.signId = row.signId;
            this.awardForm.trueName = row.trueName;
            this.awardForm.raceName = this.info.activityName;
            this.awardForm.orgName = this.info.hostOrgName;
            this.awardForm.awardName = "";
            this.awardForm.timeInfo = timestampDate2(new Date());
        },
        viewAwardLevel(row){
            this.isAwardLevelShow = true;
            this.awardForm.signId = row.signId;
            this.awardForm.trueName = row.trueName;
            this.awardForm.raceName = this.info.activityName;
            this.awardForm.orgName = this.info.hostOrgName;
            this.awardForm.awardName = row.award.awardName;
            this.awardForm.timeInfo = row.award.timeInfo;
        },
        //  imageUrl为后台提供图片地址
        doDraw(imageUrl){
            //  获取canvas
            let canvas = document.getElementById("award-canvas")
            //  由于弹窗，确保已获取到
            let a = setInterval(() =>{
                //  重复获取
                canvas = document.getElementById("award-canvas")
                if(!canvas){
                    return false
                } else {
                    clearInterval(a)
                    //  可以理解为一个画笔，可画路径、矩形、文字、图像
                    let context = canvas.getContext('2d')
                    let img = new Image()
                    img.src = imageUrl
                    //  加载图片
                    img.onload = function(){
                        if(img.complete){
                            //  根据图像重新设定了canvas的长宽
                            // canvas.setAttribute("width",img.width)
                            // canvas.setAttribute("height",img.height)
                            //  绘制图片
                            /*context.drawImage(img,0,0,img.width,img.height)*/
                            context.drawImage(img,0,0,720,500)
                        }
                    }
                }
            },1)
        },
        generateImage(){
            html2canvas(this.$refs.awardElement,
              {
                  backgroundColor:null,
                  useCORS:true,
                  scale:2,
              }).then(canvas =>{
                const imgUrl = canvas.toDataURL('image/png')
                console.log(imgUrl)
                this.awardForm.imgInfo = imgUrl;
                this.submitAwareRate();
                /*const link = document.createElement('a');
                link.download = 'award-image.png';
                link.href = imgUrl;
                link.click();*/
            })
        },
        // 提交定级信息
        submitAwareRate(){
            this.$refs["awardForm"].validate(valid => {
                if (!valid){
                    return
                }
                activitySignAwardRate(this.awardForm).then(res => {
                    if (res.data.code === 1) {
                        this.isAwardLevelShow = false;
                        this.getPageRaceSign()
                    }else{
                        this.$message.error("请求出错")
                    }
                })
            })

        },
    }
};
</script>
<style scoped>
.parent-container{
    height: 100%;
    width: 100%;
    box-sizing: border-box;
}
.content-container{
    height: 100%;
    width: 100%;
    background-color: #fff;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
}
.topic-sign-title{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    font-weight: bold;
    color: #3b62f8;
    margin-top: 5px;
    text-align: center;
    display: flex;
}
.topic-sign-title-l{
    width: 40px;
    height: 40px;
    cursor: pointer;
    padding: 5px 0 0 0;
}
.back-img{
    width: 30px;
    height: 30px;
}
.topic-sign-title-r{
    width: calc(100% - 40px);
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    font-weight: bold;
    color: #3b62f8;
    margin-top: 5px;
    text-align: center;
    text-indent: -40px;
}



.topic-sign-name{
    width: 100%;
    height: 30px;
    font-size: 15px;
    color: #333333;
    text-align: center;
}
.topic-status-container{
    width: 100%;
    height: 60px;
    border-bottom: 1px solid #3b62f8;
    display: flex;
}
.item-active{
    color: #3b62f8!important;
}
.status-item-container{
    width: 240px;
    height: 100%;
    display: flex;
    cursor: pointer;
}
.status-time-container{
    width: 220px;
    height: 100%;
}
.status-time1{
    width: 100%;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
}
.status-time2{
    width: 100%;
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
}
.status-fx-container{
    width: 20px;
    height: 100%;
    line-height: 60px;
    text-align: center;
    font-weight: bold;
    color: #989898;
}
.tab-dfp{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #ffbf6b
}
.tab-yfp{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #81b337;
}
.tab-dsh{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #4095e5
}
.tab-shtg{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #81b337;
}
.tab-shjj{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #bd3124;
}
.tab-fpsh1{
    width: 80px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #ffbf6b
}
.check-top-container{
    width: 100%;
    height: 40px;
    border-bottom: 2px solid #ccc;
    display: flex;
}
.refresh-container{
    width: 60%;
    height: 40px;
    display: flex;
    cursor: pointer;
}
.refresh-icon{
    width: 22px;
    height: 22px;
    margin-top: 9px;
    margin-left: 20px;
}
.refresh-title{
    width: auto;
    height: 30px;
    line-height: 30px;
    color: #000000;
    margin-top: 5px;
}
.search-container{
    width: 40%;
    height: 26px;
}
/deep/ .el-dialog__header{
    padding-bottom: 0!important;
}
.topic-fp-title{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    font-weight: bold;
    color: #3b62f8;
    text-align: center;
}
.fp-container{
    width: 90%;
    height: 400px;
    margin: auto;
    border-radius: 10px;
}
.fp-btn-container{
    padding-top: 10px;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;
}
.fp-scrollbar{
    width: 100%;
    height: 400px;
    margin-top: 6px;
}
.check-user-item{
    width: 100%;
    height: 70px;
    display: flex;
}
.sel-container{
    width: 80px;
    height: 70px;
    display: flex;
    padding-left: 20px;
    box-sizing: border-box;
    cursor: pointer;
}
.check-icon-container{
    width: 18px;
    height: 18px;
    margin-top: 26px;
}
.check-icon-word{
    height: 70px;
    line-height: 70px;
}
.sel-user-container{
    width: calc(100% - 100px);
    height: 60px;
    border-radius: 10px;
    border: 1px solid #ccc;
    margin-top: 4px;
    padding:0 10px 0 10px;
    box-sizing: border-box;
}
.user-check-data{
    width: 100%;
    height: 35px;
    display: flex;
    padding-top: 5px;
    box-sizing: border-box;
}
.data-user{
    width: calc(100% - 160px);
    height: 35px;
    padding-top: 5px;
    box-sizing: border-box;
    color: #333333;
    font-weight: bold;
    font-size: 14px;
}
.data-item{
    width: 80px;
    height: 35px;
    padding-top: 5px;
    box-sizing: border-box;
    color: #999999;
    text-align: right;
}
.user-check-pro{
    width: 100%;
    height: 20px;
}
.list-title-container{
    width: 100%;
    height: 20px;
    border-left: 5px solid #3b62f8;
    margin-top: 5px;
    margin-bottom: 5px;
    display: flex;
}
.list1{
    width: auto;
    height: 20px;
    line-height: 20px;
    text-indent: 5px;
    font-size: 15px;
    font-weight: bold;
    margin-right: 10px;
}
.status-info-bm{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #4095e5;
    font-size: 12px;
    text-align: center;
    color: #fff;
    text-indent: 0!important;
}
.status-info-kt{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #ffbf6b;
    font-size: 12px;
    text-align: center;
    color: #fff;
    text-indent: 0!important;
}
.status-info-zq{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #bd3124;
    font-size: 12px;
    text-align: center;
    color: #fff;
    text-indent: 0!important;
}
.status-info-jt{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #81b337;
    font-size: 12px;
    text-align: center;
    color: #fff;
    text-indent: 0!important;
}
/*奖状定级*/
.award-title{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    font-weight: bold;
    color: #3b62f8;
    text-align: center;
    margin-bottom: 10px;
}
.award-par-container{
    position: relative;
    width: 720px;
    height: 500px;
    margin-left: 25px;
}
.award-container{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%; /* 或根据需要设置宽度 */
    height: 100%;
}
.award-info-container{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%; /* 或根据需要设置宽度 */
    height: 100%;
    z-index: 1;
}
.award-info-title{
    width: 100%;
    height: 40px;
    text-align: center;
    font-size: 26px;
    font-weight: bold;
    padding: 130px 0 0 0;
    color: #8e5d3c;
}
.award-info-name{
    width: 560px;
    height: 30px;
    line-height: 30px;
    text-align: left;
    font-size: 20px;
    font-weight: bold;
    color: #000000;
    margin: auto;
    letter-spacing: 5px;
}
.award-info-race{
    width: 560px;
    height: auto;
    line-height: 30px;
    text-align: left;
    font-size: 20px;
    font-weight: bold;
    color: #000000;
    margin: auto;
    text-indent: 40px;
}
.award-info-awardname{
    width: 560px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    color: #f0cc30;
    margin: auto;
    font-family: 华文中宋,serif;
    letter-spacing: 5px;
}
.award-info-org{
    width: 560px;
    height: 30px;
    line-height: 30px;
    text-align: right;
    font-size: 20px;
    font-weight: bold;
    color: #000000;
    margin: auto;
    padding: 10px 0 0 0;
}
.award-info-time{
    width: 560px;
    height: 30px;
    line-height: 30px;
    text-align: right;
    font-size: 20px;
    font-weight: bold;
    color: #000000;
    margin: auto;
    padding: 0 80px 0 0;
}
#award-canvas{
    //border: 1px dashed rgb(199, 198, 198);
}
</style>